import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBroadcast = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 17.25v-5.5m0-3.5v-.5m-2.75-2c-.75.5-1 1.5-1 2.25s.25 1.75 1 2.25m-3-7.5c-1.375 1.625-2 3.438-2 5.25 0 1.813.625 3.625 2 5.25m11.5-10.5c1.375 1.625 2 3.438 2 5.25 0 1.813-.625 3.625-2 5.25m-3-7.5c.75.5 1 1.5 1 2.25s-.25 1.75-1 2.25"
	})]
});
const ForwardRef = forwardRef(SvgBroadcast);
export { ForwardRef as ReactComponent };
